import { DataTable } from '@components/Table/DataTable';
import { TableCheckboxCell } from '@components/Table/TableCheckboxCell';
import { TableHeaderCheckboxCell } from '@components/Table/TableHeaderCheckboxCell';
import { TableKeyCell } from '@components/Table/TableKeyCell';
import { TableSortCell } from '@components/Table/TableSortCell';
import { TableSortRow } from '@components/Table/TableSortRow';
import { IData } from '@hooks/useData';
import useFormatter from '@hooks/useFormatter';
import { IValueState } from '@hooks/useValueState';
import { TableBody, TableCell, TableContainerProps, TableHead, TableRow } from '@material-ui/core';
import ILinha from '@model/Linha';
import React from 'react';

export type FichaVendedorInventarioTableProps = {
    isLoading: boolean
    data: IData<ILinha>
    tableContainerProps?: TableContainerProps
    selectedIds: IValueState<number[]>
}

export function FichaVendedorInventarioTable ({isLoading, data, tableContainerProps, selectedIds}: FichaVendedorInventarioTableProps) {
    const formatter = useFormatter();

    const handleSelectAll = React.useCallback((checked: boolean) => {
        selectedIds.set(checked ? data.items.map(x => x.linhaId) : []);
    }, [data.items, selectedIds]);

    return (
        <React.Fragment>
            <DataTable 
                isLoading={isLoading} 
                itemCount={data.itemsCount}
                tableContainerProps={tableContainerProps}
            >
                <TableHead>
                    <TableSortRow sort={data.sort}>
                        <TableHeaderCheckboxCell selectedCount={selectedIds.value?.length ?? 0} totalCount={data.itemsCount} onSelectAll={handleSelectAll} />
                        <TableSortCell fieldName="linhaId">ID</TableSortCell>
                        <TableSortCell fieldName="contratoOperadora.empresa.nome">Empresa</TableSortCell>
                        <TableSortCell fieldName="contratoOPeradora.operadora.nome">Operadora</TableSortCell>
                        <TableSortCell fieldName="numeroSemMascara">Número</TableSortCell>
                    </TableSortRow>
                </TableHead>
                
                <TableBody>
                    {
                        data.items.map((linha) => {
                            const indexOf = selectedIds.value?.indexOf(linha.linhaId) ?? -1;
                            const checked = indexOf !== -1;

                            return (
                                <TableRow key={linha.linhaId}>
                                    <TableCheckboxCell checked={checked} onChange={(c) => {
                                        if (c) {
                                            selectedIds.set([...selectedIds.value ?? [], linha.linhaId]);
                                        }
                                        else {
                                            const newSelectedIds = [...selectedIds.value ?? []];
                                            newSelectedIds.splice(indexOf, 1);
                                            selectedIds.set(newSelectedIds);
                                        }
                                    }}></TableCheckboxCell>
                                    <TableKeyCell>{linha.linhaId}</TableKeyCell>
                                    <TableCell>{linha.contratoOperadora.empresa.nome}</TableCell>
                                    <TableCell>{linha.contratoOperadora.operadora.nome}</TableCell>
                                    <TableCell>{formatter.toCelular(linha.numeroSemMascara)}</TableCell>
                                </TableRow>
                            )
                        })
                    }
                </TableBody>
            </DataTable>
        </React.Fragment>
    )
}